import { render, staticRenderFns } from "./Contents.vue?vue&type=template&id=13b5bec4&scoped=true&"
import script from "./Contents.vue?vue&type=script&lang=ts&"
export * from "./Contents.vue?vue&type=script&lang=ts&"
import style0 from "./Contents.vue?vue&type=style&index=0&id=13b5bec4&prod&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b5bec4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Guidance: require('/opt/atlassian/pipelines/agent/build/components/guidance/Guidance.vue').default})
